import { RouterStore } from '@estee/elc-router';

import { SocialSignUpType } from '~api/RampPgApiSdk';
import { accountSignUpFormConfigName, IamType } from '~constants/Constants';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { MessageGroup, MessageRepository } from '~repositories/MessageRepository';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';

import { inStoreSignUpConfigName } from '../../../constants/Constants';
import { ConfigurationLoadedUseCase } from '../ConfigurationLoadedUseCase';

export class GoToLandingViewUseCase {
    private routerStore: RouterStore;
    private configRepository: ConfigRepository;
    private messageRepository: MessageRepository;
    private errorMessageKey?: string;

    constructor(errorMessageKey?: string) {
        this.routerStore = diContainer.get(serviceNames.routerStore);
        this.configRepository = diContainer.get(serviceNames.configRepository);
        this.messageRepository = diContainer.get(serviceNames.messageRepository);
        this.errorMessageKey = errorMessageKey;
    }

    execute = async () => {
        const { setMessages } = this.messageRepository;
        const { changeCurrentRoute } = this.routerStore;
        new ConfigurationLoadedUseCase(this.getConfigNodeName()).execute();
        if (this.errorMessageKey) {
            // show errors both for sign in and sign up when user switch between tabs
            setMessages(MessageGroup.SIGN_IN, [{ transKey: this.errorMessageKey }]);
            setMessages(MessageGroup.SIGN_UP, [{ transKey: this.errorMessageKey }]);
        }

        // get the original requested url from the callback url and change current route to it.
        const requestedRoute = window.location.pathname.replace('/', '');
        changeCurrentRoute(requestedRoute);
    };

    private getConfigNodeName = (): string => {
        const { iamType, socialSignUpType } = this.configRepository;
        const mappings = {
            [SocialSignUpType.KAKAO_GIFT]: 'ramp.kakaoGiftSocialSignUp',
            [SocialSignUpType.SSG]: 'ramp.ssgSocialSignUp'
        };
        switch (iamType) {
            case IamType.SOCIAL_SIGN_UP:
                return socialSignUpType ? mappings[socialSignUpType] : accountSignUpFormConfigName;

            case IamType.IN_STORE:
                return inStoreSignUpConfigName;
            default:
                return accountSignUpFormConfigName;
        }
    };
}
